// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"e29b3952","750":"08ed486a","838":"d0463b35"}[chunkId] + ".chunk.js";
};